module.exports = __webpack_public_path__ + "static/img/pigeon-logo.ad5a4b41.jpg";